/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/style-prop-object */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import moment from 'moment';
import React, { useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSignalStrength } from '../actions/EpikBoxes';
import utils from '../lib/utils';
import './Signals.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedo } from '@fortawesome/free-solid-svg-icons';

const items = [
  { height: '10px' },
  { height: '20px' },
  { height: '30px' },
  { height: '40px' },
  { height: '50px' },
];
const Signals = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem('jwtToken') || null;
  const boxId = useSelector(state => state.AppState.boxDetails.box._id);
  const signalStrength = useSelector(state => state.AppState.boxDetails.signalStrength);
  const boxDetails = useSelector(state => state.AppState.boxDetails.box);
  const [strength, setStrength] = useState(0);
  const [updatedDate, setUpdatedDate] = useState(null);
  const initsignalExtract = boxDetails.signalStrength;
  const initsignalDate = boxDetails.signalDate;
 
  useLayoutEffect(() => {
    let signalExtract, lastUpdatedDate;
    if (signalStrength === null && initsignalExtract !== undefined ) {
      signalExtract = initsignalExtract.split(',')[0];
      lastUpdatedDate = initsignalDate;
    } else if (signalStrength) {
      signalExtract = Object?.values(signalStrength)[0]?.split(',')[0] || null;
      lastUpdatedDate = Object?.values(signalStrength)[1] || null;
    } else {
      signalExtract = null;
      lastUpdatedDate = null;
    }
    setUpdatedDate(lastUpdatedDate);
    setStrength(utils.SignalStrengthCalculator(signalExtract));
  }, [signalStrength]);
  const onSignalReload = async () => {
     await dispatch(getSignalStrength(token, boxId));
  };

  return (
    <div className="w-100">
      <div className="d-flex align-items-end justify-content-center signal-sec">
        {items.map((item, index) => {
          if (index <= strength) {
            return strength === 1 || strength === 0 ? (
              <span
                style={{ fontSize: '24px', color: 'white' }}
                id="test-status-value"
                className="propertyValue"
                key={index}
              >
                No Signal
              </span>
            ) : (
              <div
                className="signal-section"
                style={{
                  height: item.height,
                }}
                  key={index}
              />
            );
          }
        })}
      </div>
      <div className="d-flex justify-content-between bottom-sec mt-2">
        <span className="bottom-text" id="test-status-value">
          {updatedDate ? moment(updatedDate).format('MMMM Do, h:mm:ss a') : ''}
        </span>
        <div onClick={() => onSignalReload()} className="reload-btn">
        <FontAwesomeIcon icon={faRedo} style={{ color: 'white' }}
    />        </div>
      </div>
    </div>
  );
};

export default Signals;
